import usePermittedQuery from '_api/queries/usePermittedQuery';
import { User } from '_api/types';
import { ACCOUNT_TYPE } from '_constants';

import { UseGetAllPageSizeProps } from '../types';

export const GET_ARCHIVED_USERS_IN_ORG_KEY = 'get-archived-users-in-org-key';

export const useGetArchivedUsersInOrg = (
  orgId: number,
  { page = 0, size = 1000 }: UseGetAllPageSizeProps,
) => {
  return usePermittedQuery<User[]>(
    [ACCOUNT_TYPE.ADMIN],
    () => `/user/archived/org/${orgId}?page=${page}&size=${size}`,
    {},
    [GET_ARCHIVED_USERS_IN_ORG_KEY, orgId],
    {
      enabled:
        typeof orgId === 'number' && orgId >= 0 && typeof page === 'number' && page >= 0,
      refetchOnWindowFocus: false,
    },
  );
};
